export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: '练蜜桃臀需要多久才能看到效果？',
    answer: '一般来说，在坚持科学训练和合理饮食的情况下，4-6周开始感受到臀部肌肉的紧实度提升，8-12周可以看到明显的形状变化。但每个人的基因、训练基础和投入程度不同，具体时间因人而异。关键是保持耐心和一致性，不要过早放弃。',
  },
  {
    question: '女生练臀会不会让腿变粗？',
    answer: '如果以臀部为主导的训练动作（如臀推、臀桥、后踢等）为主，腿不会明显变粗。腿变粗通常是因为过度依赖深蹲、腿举等股四头肌主导的动作。想要翘臀不粗腿，把训练重心放在伸髋类动作上，配合适量的外展训练。',
  },
  {
    question: '一周练几次臀部最合适？',
    answer: '推荐每周训练臀部2-3次，每次间隔至少48小时以保证充分恢复。例如：周一、周三、周五，或者周二、周五。频率不宜过高（每天练臀效果反而更差），也不宜过低（每周一次刺激不足）。',
  },
  {
    question: '居家训练和健身房训练哪个效果好？',
    answer: '两者各有利弊。居家训练方便灵活、时间成本低，自重训练和弹力带训练对新手效果显著。健身房训练可以使用更重的负重和多样化的器械，有利于长期渐进超负荷。最佳方案是居家和健身房结合，或者根据自己的实际情况选择最可持续的方式。',
  },
  {
    question: '练完臀部没有酸痛感，是不是训练没效果？',
    answer: '延迟性肌肉酸痛（DOMS）不是衡量训练效果的标准。酸痛只能说明肌肉受到了不习惯的刺激，不代表肌肉在增长。持续的力量进步、训练容量增加和视觉变化才是真正的效果指标。很多高效训练者在熟练动作后酸痛感会减轻，这完全正常。',
  },
  {
    question: '需要补充蛋白粉吗？',
    answer: '蛋白粉是一种便捷的蛋白质补充方式，但不是必需的。如果你能从日常饮食中摄入足够的蛋白质（每公斤体重1.6-2.2克），完全不需要蛋白粉。蛋白粉的主要优势是方便快捷，特别适合训练后快速补充，或者饮食中蛋白质摄入不足的人群。',
  },
  {
    question: '年龄大了还能练出蜜桃臀吗？',
    answer: '当然可以！力量训练对任何年龄都有效。虽然年龄增长后肌肉合成效率略有下降，但通过科学的训练和充足的蛋白质摄入，30岁、40岁甚至50岁以上的女性都能显著改善臀部形态。力量训练还能增加骨密度、改善体态和代谢健康，越早开始越好。',
  },
  {
    question: '臀部训练前需要热身吗？怎么热身？',
    answer: '热身是必不可少的环节，尤其是臀部这种"易睡"肌群。推荐5-10分钟的臀部激活热身：先做泡沫轴放松臀部和髋屈肌，然后进行蛤壳式、驴踢、弹力带侧向行走等激活动作。良好的热身能大幅提升训练效果并降低受伤风险。',
  },
];

export const aboutFAQs: FAQ[] = [
  {
    question: '你们的训练方案适合零基础新手吗？',
    answer: '完全适合。我们的内容覆盖从入门到进阶的完整路径。每个动作都有详细的分解说明和常见错误提示，新手可以从基础激活动作和自重训练开始。',
  },
  {
    question: '内容的专业度如何保证？',
    answer: '我们的内容团队由持证健身教练、运动康复师和注册营养师组成，所有训练方案和饮食建议均基于循证科学和最新运动科学研究。我们会持续跟踪学术前沿，确保内容的科学性和时效性。',
  },
  {
    question: '有没有一对一指导服务？',
    answer: '目前我们以内容分享为主，暂不提供一对一线上指导服务。但我们的文章和视频教程非常详细，你可以跟着内容自主学习。如有特殊需求，建议咨询当地专业健身教练。',
  },
];